import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { JWT_INTERCEPTOR_SKIP } from './jwt-interceptor-options';
import { TokenService } from '../../core/auth/token.service';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
    if (req.context.get(JWT_INTERCEPTOR_SKIP)) {
        return next(req);
    }

    const tokenService = inject(TokenService);

    return tokenService.getAccessToken().pipe(
        switchMap(token => {
            if (!token) {
                return next(req);
            }
            const authReq = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
            return next(authReq);
        }),
    );
};
